import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=a70635e4"
import script from "./SignUpForm.js?vue&type=script&lang=js&external"
export * from "./SignUpForm.js?vue&type=script&lang=js&external"
import style0 from "./SignUpForm.vue?vue&type=style&index=0&id=a70635e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports